

































































































































































import Vue from 'vue'
import { useModalToggle } from '~/compositions/modal-toggle'
import { computed, onMounted, ref, toRefs } from '@nuxtjs/composition-api'
import { useLogger } from '~/compositions/logger'
import { useDep } from '~/compositions/dependency-container'
import { useI18n } from '~/compositions/i18n'
import { useSnackbar } from '~/compositions/snackbar'
import AuditsOptionsService from '~/services/audits/AuditsOptionsService'
import { AuditPackage } from '~/models/audit/package'
import { AuditsOption } from '~/models/audit/options'
import { ciAuditShop } from '~/icons/source/regular/audit-shop'
import { ciFinancialPlan } from '~/icons/source/regular/financial-plan'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { ciAngleLeftLight } from '~/icons/source/solid/angle-left-light'
import AuditsShops from '~/components/shared/classified/audits/AuditsShops.vue'
import AuditPackageOverview from '~/components/shared/classified/audits/AuditPackageOverview.vue'
import AuditsPackageDetails from '~/components/shared/classified/audits/AuditsPackageDetails.vue'
import CSwipeSelector from '~/components/shared/configurable/CSwipeSelector.vue'
import AuditRequestService from '~/services/audits/AuditRequestService'
import { handleError } from '~/utils/http'
import UserBasicInfoForm from '~/components/shared/classified/audits/UserBasicInfoForm.vue'
import { useNamespacedStore } from '~/compositions/store'
import { ciMakeCarcheck } from '~/icons/source/regular/make-carcheck'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'

export default Vue.extend({
  components: {
    UserBasicInfoForm,
    CSwipeSelector,
    AuditsPackageDetails,
    AuditPackageOverview,
    AuditsShops,
    AuditsInfoSlider: () =>
      import('~/components/shared/classified/audits/AuditsInfoSlider.vue')
  },
  props: {
    classifiedId: { type: Number, required: true },
    selfAudit: { type: Boolean, required: true },
    acceptanceAuditRequest: { type: Boolean, required: true },
    visibleMyAuditStatusModal: { type: Boolean, default: false }
  },
  setup(props, { emit }) {
    const modalToggleFunc = useModalToggle()
    const { classifiedId, visibleMyAuditStatusModal, selfAudit } = toRefs(props)
    const loading = ref(false)
    const logger = useLogger()
    const snackbar = useSnackbar()
    const { t } = useI18n()
    const focusedIndex = ref(0)
    const isFaqVisible = ref(false)

    const auditsOptionsService = useDep(AuditsOptionsService)
    const auditRequestService = useDep(AuditRequestService)

    const backButtonClicked = ref(false)
    const transitioning = ref(false)
    const auditInfoSliderRef = ref(null)
    const swipeDirection = ref('swipe-left')

    const availableShopOptions = ref<AuditsOption[] | null>(null)
    const selectedShopOption = ref<AuditsOption | null>(null)
    const selectedPackage = ref<AuditPackage | null>(null)
    const missingInfo = ref<boolean>(false)

    const { state } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )
    const skipInfo = ref(false)
    const userHasAuditRequests = computed(() => {
      return state.audits?.userHasAuditRequests
    })

    const mainHash = computed(() => {
      if (selectedShopOption.value?.id) {
        if (selectedPackage.value?.id) {
          return `auditpackage-${selectedShopOption.value.id}`
        }
        return `auditshop-${selectedShopOption.value?.shop.id}`
      } else if (userHasAuditRequests.value || skipInfo.value) {
        return 'audit'
      } else if (isFaqVisible.value) {
        return 'faq'
      }
      return 'infoSlider'
    })

    const fetchAuditOptionsForClassified = async () => {
      try {
        loading.value = true
        const {
          options,
          userIsMissingInfo
        } = await auditsOptionsService.getAvailableAuditsOptionsForClassified(
          classifiedId.value
        )

        if (userIsMissingInfo) {
          swipeDirection.value = ''
          missingInfo.value = userIsMissingInfo
        }
        availableShopOptions.value = options
      } catch (error) {
        handleError(error, snackbar, logger, t)
      } finally {
        loading.value = false
      }
    }

    const goBack = () => {
      if (
        selectedShopOption.value === null &&
        !userHasAuditRequests.value &&
        skipInfo.value
      ) {
        swipeDirection.value = 'swipe-right'
        skipInfo.value = false
        window.history.go(-1)
      } else if (isFaqVisible.value) {
        swipeDirection.value = 'swipe-right'
        hideFaq()
        window.history.go(-1)
      } else {
        swipeDirection.value = 'swipe-right'
        selectedPackage.value
          ? (selectedPackage.value = null)
          : (selectedShopOption.value = null)
        backButtonClicked.value = true
        if (
          visibleMyAuditStatusModal.value &&
          window.location.hash.includes('#audits#')
        ) {
          emit('close')
        } else {
          window.history.go(-1)
        }
      }
    }
    const isBackButtonVisible = computed(
      () =>
        selectedShopOption.value !== null ||
        (selectedShopOption.value === null &&
          !userHasAuditRequests.value &&
          skipInfo.value) ||
        isFaqVisible.value ||
        visibleMyAuditStatusModal.value
    )

    const isHeaderVisible = computed(
      () =>
        isFaqVisible.value || skipInfo.value || visibleMyAuditStatusModal.value
    )

    const onModalHashChange = (e: HashChangeEvent) => {
      if (process.client && window.location.hash) {
        if (backButtonClicked.value) {
          e.preventDefault()
          e.stopPropagation()
          backButtonClicked.value = false
          // return
        }
        if (window.location.hash === '#faq') {
          showFaq()
        }
        if (window.location.hash === '#infoSlider') {
          // we just came back to step 1
          swipeDirection.value = 'swipe-right'

          if (!userHasAuditRequests.value && skipInfo.value) {
            skipInfo.value = false
          } else {
            hideFaq()
          }
        } else if (window.location.hash === '#audit') {
          swipeDirection.value = 'swipe-right'
          selectedShopOption.value = null
          selectedPackage.value = null
          skipInfo.value = true
        } else {
          const splitLocation = window.location.hash.split('-')
          if (splitLocation.length) {
            if (!splitLocation[splitLocation.length - 1]) {
              return
            }
            const currentHashType = splitLocation[0]
            const currentHashValue = parseInt(
              splitLocation[splitLocation.length - 1]
            )

            if (
              currentHashType === '#auditshop' &&
              availableShopOptions.value?.length
            ) {
              if (selectedPackage.value) {
                // we are coming back to step 2
                swipeDirection.value = 'swipe-right'
                selectedPackage.value = null
              } else {
                // we are coming forward to step 2
                swipeDirection.value = 'swipe-left'
              }
              selectedShopOption.value = availableShopOptions.value.find(
                o => o.shop.id === currentHashValue
              ) as AuditsOption
            } else if (
              currentHashType === '#auditpackage' &&
              selectedShopOption.value
            ) {
              selectedPackage.value = selectedShopOption.value.packages.find(
                p => p.id === currentHashValue
              ) as AuditPackage
            }
          }
        }
      }
    }
    onMounted(async () => {
      modalToggleFunc.setModalInSearch(false)
      modalToggleFunc.setOnHashChangeCallback(onModalHashChange)
      await fetchAuditOptionsForClassified()
    })

    const selectShopOption = (option: AuditsOption) => {
      swipeDirection.value = 'swipe-left'
      selectedShopOption.value = option
      if (option.packages.length === 1) {
        // no reason to show selector if only one package
        selectPackage(option.packages[0])
      } else {
        modalToggleFunc.goToNextHash(
          `auditshop-${selectedShopOption.value.shop.id}`
        )
      }
    }

    const selectPackage = (pkg: AuditPackage) => {
      swipeDirection.value = 'swipe-left'
      selectedPackage.value = pkg
      modalToggleFunc.goToNextHash(`auditpackage-${selectedPackage.value.id}`)
    }

    const hideModal = () => {
      if (selectedPackage.value) {
        if (selectedShopOption.value?.packages.length === 1) {
          // we are on step3 (cause theres no package select step)
          window.history.go(numberOfSteps.value + 1) // default -2
        } else {
          // if we close while we are on step 4 then go back three times
          window.history.go(numberOfSteps.value) // default -3
        }
      } else if (selectedShopOption.value) {
        // if we close while we are on step 2 then go back two time
        window.history.go(numberOfSteps.value + 1) // default -2
      } else if (
        !visibleMyAuditStatusModal.value &&
        (skipInfo.value || isFaqVisible.value)
      ) {
        window.history.go(-1)
      }
      // close will handle the removal of the initial hash
      emit('close')
    }

    const buySelectedPackage = async () => {
      if (!selectedShopOption.value?.shop.id || !selectedPackage.value?.id) {
        return false
      }
      try {
        loading.value = true

        const {
          auditRequest
        } = await auditRequestService.requestAuditForClassified(
          classifiedId.value,
          selectedShopOption.value.shop.id,
          selectedPackage.value.id
        )

        if (selectedShopOption.value.requiresAcceptance) {
          loading.value = false
          snackbar.success(t('your_request_submitted'), { time: 6000 })
          emit('close')
        } else {
          emit('create-request', auditRequest)
        }
        emit('success-audit-request')
      } catch (error) {
        handleError(error, snackbar, logger, t)
        loading.value = false // if success loading should persist until new page loads
      }
    }

    const onUserBasicInfoSuccess = () => {
      swipeDirection.value = 'swipe-left'
      missingInfo.value = false
    }

    const onShowWorkshopsClick = () => {
      modalToggleFunc.goToNextHash('audit')
      swipeDirection.value = 'swipe-left'
      skipInfo.value = true
    }

    const headerIcon = computed(() => {
      if (isFaqVisible.value) {
        return null
      } else if (selectedShopOption.value === null) {
        if (!skipInfo.value) {
          return ciMakeCarcheck
        }
        return ciAuditShop
      }
      return ciFinancialPlan
    })

    const numberOfSteps = computed(() => {
      return visibleMyAuditStatusModal.value || selfAudit.value ? -2 : -3
    })

    function showFaq() {
      if (auditInfoSliderRef.value?.showFaq) {
        isFaqVisible.value = true
        auditInfoSliderRef.value.showFaq()
      }
    }

    function hideFaq() {
      isFaqVisible.value = false
      if (auditInfoSliderRef.value?.hideFaq) {
        auditInfoSliderRef.value.hideFaq()
      }
    }

    function handleShowFaq() {
      isFaqVisible.value = true
      modalToggleFunc.goToNextHash('faq')
    }
    return {
      modalToggleFunc,
      loading,
      hideModal,
      fetchAuditOptionsForClassified,
      swipeDirection,
      transitioning,
      goBack,
      mainHash,
      selectedShopOption,
      availableShopOptions,
      selectShopOption,
      selectedPackage,
      selectPackage,
      ciAuditShop,
      ciFinancialPlan,
      faTimes,
      ciAngleLeftLight,
      buySelectedPackage,
      focusedIndex,
      missingInfo,
      onUserBasicInfoSuccess,
      userHasAuditRequests,
      skipInfo,
      ciMakeCarcheck,
      headerIcon,
      onShowWorkshopsClick,
      isFaqVisible,
      auditInfoSliderRef,
      handleShowFaq,
      numberOfSteps,
      isBackButtonVisible,
      isHeaderVisible
    }
  }
})
